<template>
  <div class="wrapper">
    <div class="container">
      <div class="img">
        <i class="iconfont iconicon_error"></i>
      </div>
      <h4>
        支付失败
        <small>再试一次</small>
      </h4>
      <div class="btn">
        <van-button style="width:282px;" plain color="#1E8DFF" @click="handlePayAgain">
          再次购买
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import jumpCenter from '@/mixins/jumpCenter';

export default {
  mixins: [jumpCenter],
  methods: {
    handlePayAgain() {
      const orderId = this.$route.query.orderId || '';
      if (orderId) {
        this.jumpToMallOrderDetail(orderId);
      } else {
        // this.$router.go(-1);
        this.jumpToMallOrderList();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  text-align: center;
  background-color: #eee;
  height: 100%;
  .container {
    padding: 32px 0 28px;
    background-color: #fff;
    min-height: 243px;
    > h4 {
      font-size: 18px;
      margin: 0;
      margin-bottom: 30px;
      color: #333;
      small {
        display: block;
        color: #999;
        padding-top: 10px;
        font-size: 14px;
      }
    }
    > p {
      color: #666;
      margin-bottom: 24px;
    }
    .iconicon_error {
      color: #ff5500;
      font-size: 44px;
    }
    .van-button {
      height: 48px;
      line-height: 48px;
      font-size: 18px;
    }
  }
}
.img {
  width: 44px;
  margin: 0 auto 20px;
}
</style>
